import type { FaireProductEntity } from "../../entity_types/product";

export const p_f6svzp7vwx: FaireProductEntity = {
  token: "p_f6svzp7vwx",
  type: "product",
  name: 'Nature Inspired Mug with Alcove-4"H(11oz)',
  brandToken: "b_a8n58zvndo",
  brandName: "Abbott",
  imageUrl:
    "https://cdn.faire.com/fastly/7b3f1421faca4dff4cf659df1fe60832f1fce2867d0f34526853fb2745ee4f24.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/bad4bf765e558d4ae588b951c57a69661e792db38fedd58d0b004061424fc899.jpeg",
    "https://cdn.faire.com/fastly/f58b2bf1b6460721050b226fb0c6da848cf98e29f08306d6da00fb0ea4aadf6d.jpeg",
    "https://cdn.faire.com/fastly/fbb15e3740453eb3a051a8ca22163fa5642cbb0659aa70f0035c3702899d80b0.jpeg",
    "https://cdn.faire.com/fastly/a5afed83d2f4d10f0228ee97e98e956f4595c09143b0206862ca03624ccf642d.jpeg",
    "https://cdn.faire.com/fastly/19f27a9051ce7127ccf3e0961be77a3bb301d1cf5c3b76ef4c5f842f76488eca.jpeg",
    "https://cdn.faire.com/fastly/537b8c0e8a8d231a92504681dd60b8ea5d225cd8ec2f2b6305c159698a472189.jpeg",
    "https://cdn.faire.com/fastly/7e18032a0bc391997b25a8d64508a8b1b56a5823d6b383f608c422a2e48ddf23.jpeg",
  ],
  priceDollars: 8.5,
  description:
    "This charming Natural Inspired Mug features a unique alcove with woodland icons tucked inside. Crafted from textured stoneware, the mug combines functionality with artistic flair. Its comfortable handle and generous size make it perfect for savouring your favourite beverages adding a touch of nature-inspired whimsy to your morning routine.",
  tags: [],
  msrpDollars: 17,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-05-06T19:58:11.229Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
